import { useQuery } from '@tanstack/react-query';
import eduzzAccountsService from 'v2/services/eduzzAccount';

export function useGetBetaFeatures() {
  return useQuery({
    queryKey: ['beta-features'],
    queryFn: () => eduzzAccountsService.getBetaFeatures()
  });
}
